export default function CancellationPolicyPage() {
    return (
        <div className="container -legalPages main">
            <div className="row">
                <div className="col-md-8 offset-md-2">
                    <div className="row d-flex header-container">
                        <h2 className="header">
                            Cancellation Policy
                        </h2>
                    </div>
                    <br />
                    <div className="row d-flex">
                        <p>
                            You can amend your appointment as many times as you like. Cancellations made less than 48 hours before
                            the test will not be refunded. Cancellations made more than 48 hours in advance of the testing carry a
                            cancellation fee of %30 of the total testing fee.
                        </p>
                        <p>
                            If you do not advise us of your non attendance, you will not receive a refund and will not be able to
                            use the payment towards a new appointment. If you do need to change your appointment, please advise us
                            as early as possible.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}